<template>
  <div
    id="navigation-slide"
    class="navigation-slide">
    <div class="navigation-slide__top">
      <div class="navigation-slide__contact">
        <oie-base-action
          v-tooltip="tStatic('customerServiceInCurrentLanguage') ? {content: tStatic('customerServiceInCurrentLanguage'), placement: 'bottom', classes: 'inverted'} : undefined"
          theme="link"
          :aria-label="`${tStatic('phone')} ${headerSettings.startPageReference.companyPhoneTitle}`"
          :url="`tel:${headerSettings.startPageReference.companyPhone}`">
          <template #iconPrepend>
            <oie-base-icon icon="phone" size="s"></oie-base-icon>
          </template>
          {{ headerSettings.startPageReference.companyPhoneTitle }}
          <template v-if="tStatic('customerServiceInCurrentLanguage')" #iconAppend>
            <oie-base-image
              :images="`/globalassets/languages/country_${clientModel.currentLanguage}.webp`"
              alt-text=""
              image-width="15px"
              image-height="15px"></oie-base-image>
          </template>
        </oie-base-action>
        <oie-base-action
          theme="link"
          :aria-label="`${tStatic('phone')} ${headerSettings.startPageReference.companyPhoneTitle}`"
          :url="`mailto:${headerSettings.startPageReference.companyOrderEmail}`">
          <template #iconPrepend>
            <oie-base-icon icon="email" size="s"></oie-base-icon>
          </template>
          {{ headerSettings.startPageReference.companyOrderEmail }}
        </oie-base-action>
      </div>
      <nav aria-label="primary">
        <ul class="navigation-slide__nav-list">
          <li v-for="item in headerSettings.headerNavigationItems" :key="item.title">
            <a
              :href="item.url"
              class="navigational-item navigational-item--arrow navigational-item--dark-blue navigation-slide__link">
              {{ item.title }}
            </a>
          </li>
          <li v-if="clientModel.isAuthenticated && clientModel.enableShoppingListExtended">
            <a
              :href="headerSettings.startPageReference.fastOrderMenuUrl"
              class="navigational-item navigational-item--arrow navigational-item--dark-blue navigation-slide__link navigational-item--fastorder"
              @click.stop="handleExternalMyPagesNavigation(get(headerSettings, 'startPageReference.fastOrderMenuUrl'))">
              <oie-use-svg svg="fastlist"></oie-use-svg>
              {{ headerSettings.startPageReference.fastOrderMenuTitle }}
            </a>
          </li>
        </ul>
      </nav>
    </div>

    <div class="navigation-slide__bottom">
      <a :href="headerSettings.startPageReference.contactMenuUrl" class="navigational-item navigational-item--arrow navigational-item--gray navigational-item--dark-blue">
        <oie-use-svg svg="chat" css-classes="navigation-item__icon"></oie-use-svg>{{ headerSettings.startPageReference.contactMenuUrlTitle }}
      </a>

      <a v-if="!clientModel.isAuthenticated" :href="headerSettings.loginUrl" class="navigational-item navigational-item--arrow navigational-item--gray navigational-item--dark-blue">
        <oie-use-svg svg="user" css-classes="navigation-item__icon"></oie-use-svg>{{ headerSettings.startPageReference.loginMenuTitle }}
      </a>

      <a v-if="clientModel.isAuthenticated && clientModel.myPageUrl" :href="clientModel.myPageUrl" class="navigational-item navigational-item--arrow navigational-item--gray navigational-item--dark-blue">
        <oie-use-svg svg="user" css-classes="navigation-item__icon"></oie-use-svg>{{ tStatic('myAccountMenuItem') }}
      </a>

      <!-- MOBILE -->
      <oie-navigation-market-selector
        v-if="mq('to-small')"
        :referrer-url="headerSettings.referrerUrl"
        :available-markets="headerSettings.availableMarkets">
      </oie-navigation-market-selector>

      <!-- DESKTOP -->
      <oie-the-header-market-selector
        v-show="mq('small')"
        :referrer-url="headerSettings.referrerUrl"
        :available-markets="headerSettings.availableMarkets">
      </oie-the-header-market-selector>

      <oie-the-header-account-logout-mobile v-if="clientModel.isAuthenticated"></oie-the-header-account-logout-mobile>

      <oie-list-price-switch v-if="clientModel.isAuthenticated && clientModel.hasCustomerPrices" is-for="list-price"></oie-list-price-switch>

      <oie-vat-switch is-for="vat-switch" :force-off="clientModel.hideVatSwitch"></oie-vat-switch>
    </div>
  </div>
</template>

<script>
import { mixinExternal } from '@/mixins/my-pages'

export default {
  mixins: [mixinExternal],
  props: {
    headerSettings: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss">

.navigation-slide {
  width: 100%;
  position: fixed;
  top: 60px;
  z-index: 199;
  color: white;
  overflow-y: auto;
  max-height: 80%;
}

.navigation-slide__top {
  @include container;
  padding-top: measure(half);
  padding-bottom: measure(half);
  background-color: color(header-background);
}

.navigation-slide__nav-list {
  @include reset-list;
}

.navigation-slide__nav-list > :not(:last-child) {
  margin-bottom: measure(quarter);
}

.navigation-slide__contact {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: measure(quarter);
  margin-bottom: measure(half);

  @include media(x-small) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.navigation-slide__contact > * {
  @include body-smaller;
  justify-content: center;
}

.navigation-slide__link {
  border-radius: other(border-radius);
}

.navigation-slide__bottom {
  @include container;
  background-color: color(gray-1);
  padding-top: measure(half);
  padding-bottom: measure(half);
}

.navigation-slide__bottom > *:not(:last-child) {
  margin-bottom: measure(eighth);
}

</style>
